/* eslint-disable no-lonely-if */
/* eslint-disable no-nested-ternary */
import React, { ReactElement, useMemo } from 'react';

import { Col, Divider, Layout, Row, TypographyText } from '@components/atoms';
import { noYnSurveys, requiredYnSurveys, insuranceSurveyObj, Gender } from '@constants/enum';
import { MODE_SELECT_TITLE, MODE_SELECT_GUIDE } from '@constants/text';
import { useReduxForm } from '@hooks/useReduxForm';
import { getSurveyObj } from '@utils/surveyUtils';
import _ from 'lodash';

function ModeSelect(): ReactElement {
  /**
   * 어떤 설문들을 진행할 지 결정하는 화면
   * surveyList: string[] - 선택된 설문 코드를 저장하는 배열
   * */
  const { formData, setFormData } = useReduxForm('survey');
  const { selectedMainSurveyCode, selectedInsuranceSurveyCode } = formData;

  const targetInsuranceSurveyCode = useMemo(() => {
    let codes = _.keys(insuranceSurveyObj);
    if (formData?.patient?.gender === Gender.Male) {
      codes = _.without(codes, 'B'); // 남성은 월경통 설문 안함
    }
    return codes;
  }, []);

  const category = useMemo(
    () => [
      ..._.map(targetInsuranceSurveyCode, (k: string, index: number) => ({
        index,
        label: getSurveyObj(k).label,
        value: k,
        colSpan: 1,
      })),
      {
        colSpan: 2,
        label: '해당 없음(일반 설문으로 진행됩니다)',
        value: 0,
      },
    ],
    [],
  );

  return (
    <Layout yzTypeLayout="SURVEY">
      <Row style={{ display: 'flex', paddingInline: '5px', marginTop: '20px' }}>
        <img
          alt="첩약건보 혜택 안내"
          src={`${process.env.PUBLIC_URL}/img/insurance-info.webp`}
          width="100%"
        />
      </Row>
      <Divider margin={8} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row gutter={[0, 5]} style={{ rowGap: '6px', paddingInline: '7px' }}>
        {
          // eslint-disable-next-line react/no-unused-prop-types
          category.map(({ value, label, colSpan }) => {
            const colspan2Flag = colSpan === 2;
            const checked = selectedInsuranceSurveyCode === value;
            return (
              <Col
                onClick={() => {
                  if (checked) {
                    const body = {
                      mode: undefined,
                      [value]: undefined,
                      [`${value}Next`]: undefined,
                      selectedMainSurveyCode: undefined,
                      selectedInsuranceSurveyCode: undefined,
                      surveyList: [],
                    };
                    setFormData(body);
                    // console.log(body);
                  } else {
                    if (value === 0) {
                      const body: any = {
                        mode: 'GENERAL',
                        [selectedMainSurveyCode]: undefined,
                        [`${selectedMainSurveyCode}Next`]: undefined,
                        selectedMainSurveyCode: undefined,
                        selectedInsuranceSurveyCode: 0,
                        surveyList: [],
                      };
                      setFormData(body);
                    } else {
                      const body: any = {
                        mode: value,
                        selectedMainSurveyCode: value,
                        selectedInsuranceSurveyCode: value,
                        surveyList: [value],
                      };
                      if (selectedMainSurveyCode !== 0) {
                        body[selectedMainSurveyCode] = undefined;
                        body[`${selectedMainSurveyCode}Next`] = undefined;
                      }
                      if (![...requiredYnSurveys, ...noYnSurveys].includes(value as string)) {
                        body[value] = 1;
                        body[`${value}Next`] = getSurveyObj(value as string)?.answers?.find(
                          (e) => e?.value,
                        )?.next;
                      }
                      setFormData(body);
                    }
                    // console.log(body);
                  }
                }}
                oneColumnInRowFlag={colspan2Flag}
                span={colspan2Flag ? 24 : 12}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                twoColumnsInRowFlag={!colspan2Flag}
                yzTypeCol={checked ? 'selected-onset-button' : 'onset-button'}
              >
                <TypographyText yzTypeTypographyText="basic">{label}</TypographyText>
              </Col>
            );
          })
        }
      </Row>
      <Divider margin={42} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
    </Layout>
  );
}

export default ModeSelect;
